/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON, } from './FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus';
/**
 * Check if a given object implements the FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand interface.
 */
export function instanceOfFxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand(value) {
    if (!('PublicOrderId' in value) || value['PublicOrderId'] === undefined)
        return false;
    if (!('Status' in value) || value['Status'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSON(json) {
    return FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSONTyped(json, false);
}
export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PublicOrderId': json['PublicOrderId'],
        'Status': FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON(json['Status']),
    };
}
export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSON(json) {
    return FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSONTyped(json, false);
}
export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PublicOrderId': value['PublicOrderId'],
        'Status': FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON(value['Status']),
    };
}
//# sourceMappingURL=FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand.js.map